import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider, useLang } from "./contexts/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppFab from "./components/WhatsAppFab";
import Home from "./pages/Home";
import ServicesPage from "./pages/ServicesPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";

function Shell() {
  const { dir } = useLang();
  const isRTL = dir === "rtl";
  const fontClass = isRTL ? "font-tajawal" : "font-inter";
  const alignClass = isRTL ? "text-right" : "text-left";

  return (
    <div className={`App relative ${fontClass} ${alignClass}`} data-testid="app-root">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppFab />
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          className: fontClass,
          style: {
            background: "#0A1428",
            border: "1px solid rgba(0,240,255,0.4)",
            color: "#F8FAFC",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Shell />
      </BrowserRouter>
    </LanguageProvider>
  );
}
